<template>
	<div class="container">
		<div style="position: absolute;width: 100%;z-index: -1;">
			<img src="@/assets/image/login/register_top.jpg" style="width: 100%;height: 90px;" alt="">
		</div>
		<login-header :info="webInfo"></login-header>
		<user v-if="index==1"></user>
		<manufacturer v-if="index==2"></manufacturer>
		<electrician v-if="index==3"></electrician>
		<!-- <div class="footer">
			备案信息：{{webInfo.websiteNumber}}
		</div> -->

		<div style="width: 785px;margin: 25px auto;text-align: center;font-size: 16px;color: #3f3f3f;">
			<div style="margin-top: 20px;">
				冀icp备2020029693号 冀公司安备1301990200540号
			</div>
			<div style="margin-top: 10px;">
				建议使用分辨率124X768以上
			</div>
		</div>
	</div>
</template>

<script>
	import loginHeader from '../../components/loginHeader/index.vue'
	// import user from "../../components/register/user.vue"
	import user from "./components/user.vue"
	import manufacturer from "../../components/register/manufacturer.vue"
	// import electrician from "../../components/register/electrician.vue"
	import electrician from "./components/electrician.vue"
	import {webInfoApi} from '../../http/api/user.js'

	export default{
		components:{
			user,
			manufacturer,
			electrician,
			loginHeader
		},
		data(){
			return{
				index:0,
				webInfo: {}
			}
		},
		created() {
			this.index=this.$route.query.value
			webInfoApi().then(res => {
				this.webInfo = res
			})
		}
	}
</script>

<style scoped lang="less" scoped>
	.footer {
		width: 100%;
		display: flex;
		justify-content: center;
		font-size: 14px;
		color: #ADADAD;
		position: fixed;
		bottom: 30px;
	}
</style>
